export default __webpack_public_path__ + "static/media/bash.d00f79ab.svg";